// Polyfill Stuffs
import 'es5-shim';
import 'es6-shim';
import 'json3';
import 'console-polyfill';



// WEBPACK FOOTER //
// ./src/polyfills.js